import React from "react";
import { useSelector } from "react-redux";
import { useStretchCoreFeedback } from "../../../../hooks/Demo/feedbackTypes";
import { loadExerciseConfigAudio } from "../../../../utilities/Demo/audioFeedback";
import { stretchScore } from "../../../../utilities/Demo/ExerciseManagement/Generators/scoreComputations";
import FeedbackGenerator from "./FeedbackGenerator";

export default function StretchFeedbackGenerator({
  onComplete,
  config,
  showWebcam,
}) {
  const iterLanguage = useSelector(({ iter }) => iter.values.language);
  const {
    updateFeedback,
    candidates,
    seconds,
    playAudio,
    audioFeedback,
    setStartingTime,
    setSide,
    finishedIntro,
  } = useStretchCoreFeedback({
    onComplete,
    timeThresh: config.timeThresh,
    loadAudio: () => loadExerciseConfigAudio(config, iterLanguage),
    min: config.stretchTargetExtreme === "min",
    maxScore: config.scoreConfig?.maxScore || 10,
    calculatePoints: (reachedCentimeters) =>
      stretchScore({ config, targetRef: reachedCentimeters }),
  });

  const onCorrect = ({ refValue, axis }) => {
    let pushValue = refValue[axis] ? refValue[axis] : refValue;
    candidates.current.push(pushValue);
    setStartingTime(seconds);
  };

  return (
    <FeedbackGenerator
      updateFeedback={updateFeedback}
      config={config}
      finishedIntro={finishedIntro}
      onCorrect={onCorrect}
      setSide={setSide}
      playAudio={playAudio}
      audioFeedback={audioFeedback}
      showWebcam={showWebcam}
    />
  );
}
